class BsoQuantityVariants extends HTMLElement {
  constructor() {
    super();
    this.is_selling_plan_default = true;
    this.onSwatchClick = this.onSwatchClick.bind(this);
    this.bsoSellingPlan = document.querySelector('bso-selling-plan');
    this.mainPrice = Number(this.getAttribute('main-price')) || null;
    this.mainComparePrice = Number(this.getAttribute('main-compare-price')) || 0;
    this.unitPrice = Number(this.getAttribute('unit-price')) || null;
    this.unitPriceMeasurement = this.getAttribute('unit-price-measurement');
    this.unitQuantityValue = Number(this.getAttribute('unit-quantity-value')) || null;
    this.subscriptionPlan = document.querySelector('.bso-subscription .subscription-plan');
    this.subscriptionPlanDiscount = Number(this.subscriptionPlan?.getAttribute('subscription-discount')) || 1;

    this.volumeDiscountGallery = document.querySelector('media-gallery.volume-discount-gallery') ?? null;
    this.volumeDiscountThumbnail = this.volumeDiscountGallery?.querySelector('.thumbnail-slider') ?? null;
    this.volumeDiscountMediaCount = this.volumeDiscountGallery ? this.volumeDiscountGallery.querySelectorAll('.product__media-list .product__media-item').length : 0;

    this.translations = JSON.parse(document.querySelector('[data-translation-json]').innerHTML);
    this.enableCustomSubscriptionTemplate = document.querySelector('.buy-buttons-form[enable-custom-appstle]');

    if ( this.enableCustomSubscriptionTemplate ) {
      this.detachAppstleWidget();
    }
  }

  detachAppstleWidget() {
    setTimeout(() => {
      const appstleSubscription = document.querySelector('.appstle_sub_widget.WIDGET_TYPE_1');
      if (appstleSubscription) {
        appstleSubscription.remove();
      }
    }, 1500);
  }

  connectedCallback() {
    this.swatches = this.querySelectorAll('.product__info-container .quantity-swatch');
    this.currency = document.documentElement.lang === 'de' ? 'EUR' : 'EUR';

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', this.onSwatchClick);
    });

    document.addEventListener('volume:thumbnail-change', this.onThumbnailChange.bind(this));

    requestAnimationFrame(() => {
      this.recalcPrice('onload');
      this.initQuantityInputListener();
    });

    document.addEventListener(
      'sellingPlanGroupSelect',
      this.onSellingPlanChange
    );
  }

  disconnectedCallback() {
    this.swatches.forEach((swatch) => {
      swatch.removeEventListener('click', this.onSwatchClick);
    });

    document.removeEventListener(
      'sellingPlanGroupSelect',
      this.onSellingPlanChange
    );
  }

  onSellingPlanChange = (event) => {
    this.is_selling_plan_default = event.detail.is_default;

    this.recalcPrice(
      'sellingPlanGroupSelect',
      event.detail.is_default
    );
  };

  onSwatchClick(event) {
    const swatch = event.currentTarget;
    this.swatches.forEach((el) => el.classList.remove('selected'));
    swatch.classList.add('selected');

    // Extract data
    const quantity = Number(swatch.dataset.itemQty);
    const basePrice = Number(swatch.dataset.price);
    const discountValue = Number(swatch.dataset.discountValue);
    const comparePrice = Number(swatch.dataset.comparePrice);
    this.updateQuantity(quantity, basePrice, discountValue, comparePrice);

    const swatchNumber = swatch.dataset.swatchNumber;
    if (this.volumeDiscountGallery && this.volumeDiscountMediaCount > 0) {
      this.dispatchEvent(
        new CustomEvent('volume:swatch-change', {
          bubbles: true,
          detail: {
            swatch,
            swatchNumber,
            quantity,
            basePrice,
            discountValue,
            comparePrice
          }
        })
      );
    }
  }

  formatMoney(value) {
    return "€" + value.toFixed(2).replace('.', ',');
  }

  formatUnitPrice(value) {
    return  "€" + value.toFixed(2).replace('.', ',');
  }

  getDiscountForQuantity(discountData, quantity) {
    let discount = 1.0;
    if (!discountData) return discount;
    discountData.discounts.forEach(item => {
      if( quantity >= item.quantity && item.discount_type === 'Percent' ) {
        discount = (100 - item.discount_value) / 100.0;
      }
    });

    return discount;
  }

  recalcPrice(event_name, is_default = true) {
    const price = this.mainPrice;
    const discountData = JSON.parse(document.querySelector('[data-volume-discount]').innerHTML);
    const quantityInput = document.querySelector('.product__info-container .quantity__input');
    const compare_price = this.mainComparePrice;
    let quantity = parseInt(quantityInput?.value || 1, 10);
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    const discount = this.getDiscountForQuantity(discountData, quantity);
    this.adjustPrice(quantity, price, discount, event_name, is_default, compare_price);
    const swatches = [...document.querySelectorAll('.rounded-swatch[data-item-qty]')];
    let selectedSwatch = swatches
      .map(swatch => ({
        el: swatch,
        qty: parseInt(swatch.dataset.itemQty, 10)
      }))
      .filter(swatch => swatch.qty <= quantity)
      .sort((a, b) => b.qty - a.qty)[0];
    swatches.forEach(s => s.classList.remove('selected'));
    if (selectedSwatch) {
      selectedSwatch.el.classList.add('selected');
    }
  }

  initQuantityInputListener() {
    const quantityInput = document.querySelector('.product__info-container .quantity__input');
    if (!quantityInput) return;

    quantityInput.addEventListener('change', () => {
      let quantity = parseInt(quantityInput.value, 10) || 1;
      if (quantity < 1) quantity = 1;
      quantityInput.value = quantity;

      this.recalcPrice('quantity__input', this.is_selling_plan_default);
      const swatches = [...this.swatches];
      const selectedSwatch = swatches
        .map(s => ({ el: s, qty: parseInt(s.dataset.itemQty, 10) }))
        .filter(s => s.qty <= quantity)
        .sort((a, b) => b.qty - a.qty)[0];
      if (selectedSwatch) {
        // Update swatch selection
        this.swatches.forEach(el => el.classList.remove('selected'));
        selectedSwatch.el.classList.add('selected');

        // 3️⃣ Dispatch event to update gallery thumbnail
        const swatchNumber = Number(selectedSwatch.el.dataset.swatchNumber);
        document.dispatchEvent(new CustomEvent('volume:swatch-change', {
          bubbles: true,
          detail: {
            swatch: selectedSwatch.el,
            swatchNumber,
            quantity,
            basePrice: Number(selectedSwatch.el.dataset.price),
            discountValue: Number(selectedSwatch.el.dataset.discountValue),
            comparePrice: Number(selectedSwatch.el.dataset.comparePrice)
          }
        }));
      }
    });
  }

  updateQuantity(newQuantity, price, discount, compare_price) {
    const quantityInput = document.querySelector('.product__info-container .quantity__input');
    const event_name = 'volume_discount';
    if (quantityInput) quantityInput.value = newQuantity;
    this.adjustPrice(newQuantity, price, discount, event_name, this.is_selling_plan_default, compare_price);
  }

  adjustPrice(quantity, price, discount, event_name, is_default = true, compare_price = 0) {
    const actualPrice = price * quantity;
    const discountedPrice = actualPrice * discount;
    const subscriptionDiscount = this.subscriptionPlanDiscount;

    let subscriptionPrice
    let formattedDiscounted;
    let formattedActual;
    let formattedBasePrice;
    let formattedDiscountedBasePrice;
    let unitSubscription;
    let priceSubPerUnit;
    let formattedUnitPrice;
    let discountedUnitPrice;
    let basePriceWithDiscount;
    let pricePerUnit;
    let totalPriceWithDiscount;
    let baseSubscriptionPriceWithDiscount;
    let subsPricePerUnit;
    let totalSubscriptionPriceWithDiscount;
    let totalRegularPrice;

    const totalWeightKg = quantity * (this.unitQuantityValue / 1000);
    discountedUnitPrice = discountedPrice / totalWeightKg;

    if ( discount == 1 ) {
      subscriptionPrice = discountedPrice * subscriptionDiscount;
      formattedActual = this.formatMoney(actualPrice);
      formattedDiscounted = this.formatMoney(discountedPrice);
      unitSubscription = this.formatUnitPrice((price * discount) * subscriptionDiscount);
      priceSubPerUnit = subscriptionPrice / totalWeightKg;
      formattedBasePrice = this.formatMoney(price);
      formattedDiscountedBasePrice = this.formatMoney(subscriptionPrice);
      if (this.subscriptionPlan?.classList.contains('active')) {
        formattedUnitPrice = this.formatUnitPrice(priceSubPerUnit);
      } else {
        formattedUnitPrice = this.formatUnitPrice(discountedUnitPrice);
      }
    } else {
      formattedActual = this.formatMoney(actualPrice);
      basePriceWithDiscount = price * discount;
      pricePerUnit = Math.ceil((basePriceWithDiscount + Number.EPSILON) * 100) / 100;
      if( this.mainComparePrice != "0" ) {
        totalRegularPrice = price * quantity;
        formattedDiscounted = this.formatMoney(totalRegularPrice);
      } else {
        totalPriceWithDiscount = pricePerUnit * quantity;
        formattedDiscounted = this.formatMoney(totalPriceWithDiscount);
      }

      baseSubscriptionPriceWithDiscount = price * discount * subscriptionDiscount;
      subsPricePerUnit = Math.ceil((baseSubscriptionPriceWithDiscount + Number.EPSILON) * 100) / 100;
      unitSubscription = this.formatUnitPrice(subsPricePerUnit);

      totalSubscriptionPriceWithDiscount = subsPricePerUnit * quantity;
      subscriptionPrice = totalSubscriptionPriceWithDiscount;
      formattedDiscountedBasePrice = this.formatMoney(subscriptionPrice);

      priceSubPerUnit = totalSubscriptionPriceWithDiscount / totalWeightKg;
      if (this.subscriptionPlan?.classList.contains('active')) {
        formattedUnitPrice = this.formatUnitPrice(priceSubPerUnit);
      } else {
        formattedUnitPrice = this.formatUnitPrice(discountedUnitPrice);
      }
    }

    const formattedSubscription = 
      this.formatMoney(subscriptionPrice) +
      ` <span class="line-through">${formattedDiscounted}</span>` +
      `<br><span class="unit-price">(${unitSubscription} €/${this.translations.bag})</span>`;

    const priceContainer = document.querySelector(".product__info-container .pdp-price > .price");
    const regularPriceContainer = document.querySelector(".product__info-container .price__regular");
    const salePriceContainer = document.querySelector(".product__info-container .price__sale");
    const unitPriceContainer = document.querySelector(".product__info-container .pdp-price .unit-price");
    let unitEl = null;
    if ( unitPriceContainer) {
      unitEl = unitPriceContainer.querySelector("span[data-unit-price] price-money bdi");
    }

    const sellingPlanGroupDefaultPricePerValue = document.querySelector('.selling-plan-group.selling-plan-group--default .per-delivery-price--value');
    const subscriptionPlanPerDeliveryPrice = document.querySelector('.subscription-plan .per-delivery-price--value');

    if (discount == 1) {
      if (regularPriceContainer) {
        const regularEl = regularPriceContainer.querySelector(".price-item--regular bdi");
        // Subscription group update
        if (regularEl) {
          if (sellingPlanGroupDefaultPricePerValue) {
            sellingPlanGroupDefaultPricePerValue.innerText = formattedActual;
          }
          const subscriptionUnitPrice = this.formatUnitPrice(price * subscriptionDiscount);
          if(subscriptionPlanPerDeliveryPrice) {
            subscriptionPlanPerDeliveryPrice.innerHTML =
                this.formatMoney(actualPrice * subscriptionDiscount) +
                ` <span class="line-through">${formattedActual}</span>` +
                `<br><span class="unit-price">(${subscriptionUnitPrice} €/${this.translations.bag})</span>`;
          }
        }
        // when event is coming from subscription
        if (event_name == 'sellingPlanGroupSelect' && is_default != true ) {
          priceContainer.classList.add('price--on-sale');
          if (regularPriceContainer) regularPriceContainer.style.display = "none";
          if (salePriceContainer) {
            salePriceContainer.style.display = "flex";
            const saleEl = salePriceContainer.querySelector("dd .price-item--sale bdi");
            const originalEl = salePriceContainer.querySelector("dd .price-item--regular bdi");
            originalEl.style.display = "flex";

            if (saleEl && originalEl) {
              saleEl.innerHTML = formattedDiscountedBasePrice;
              originalEl.innerText = formattedBasePrice;
              if (unitPriceContainer) {
                unitEl.innerText = formattedUnitPrice;
              }
            }
          }
        } else {
          if (regularPriceContainer) regularPriceContainer.style.display = "block";
          if (salePriceContainer) salePriceContainer.style.display = "none";
          priceContainer.classList.remove('price--on-sale');
          const regularEl = regularPriceContainer.querySelector(".price-item--regular bdi");
          if (regularEl) {
            regularEl.innerText = formattedActual;
            if (unitPriceContainer) {
              unitEl.innerText = formattedUnitPrice;
            }
          }
          if ( compare_price != 0 ) {
            regularPriceContainer.style.display = "none";
            salePriceContainer.style.display = "flex";
            const saleEl = salePriceContainer.querySelector(".price-item--sale");
            const originalEl = salePriceContainer.querySelector(".price-item--regular");
            originalEl.innerText = this.formatMoney(compare_price);
            saleEl.innerText = formattedActual;
          }
        }
      }
    } else {
      if (regularPriceContainer) regularPriceContainer.style.display = "none";
      const saleEl = salePriceContainer.querySelector("dd .price-item--sale") || salePriceContainer.querySelector("dd .price-item--sale bdi");
      const originalEl = salePriceContainer.querySelector("dd .price-item--regular") || salePriceContainer.querySelector("dd .price-item--regular bdi");
      let unitEl = null;
      if ( unitPriceContainer) {
        unitEl = unitPriceContainer.querySelector("span[data-unit-price] price-money bdi");
      }
      if (event_name == 'sellingPlanGroupSelect' ) {
        if ( is_default ) {
          salePriceContainer.style.display = "flex";
          if (saleEl && originalEl) {
            originalEl.style.display = "flex";
            originalEl.innerText = formattedActual;
            saleEl.innerText = formattedDiscounted;
            if ( unitPriceContainer) {
              unitEl.innerText = formattedUnitPrice;
            }
          }
        } else {
          if (salePriceContainer) {
            salePriceContainer.style.display = "flex";
            if (saleEl && originalEl) {
              originalEl.innerText = formattedDiscounted;
              saleEl.innerText = formattedDiscountedBasePrice;
              if ( unitPriceContainer) {
                unitEl.innerText = formattedUnitPrice;
              }
            }
          }
        }
      } else {
        if ( is_default && this.bsoSellingPlan ) {
          priceContainer.classList.add('price--on-sale');
          salePriceContainer.style.display = "flex";
          if (saleEl && originalEl) {
            originalEl.innerText = formattedActual;
            saleEl.innerText = formattedDiscounted;
            if ( unitPriceContainer) {
              unitEl.innerText = formattedUnitPrice;
            }
          }
        } else {
          if (salePriceContainer) {
            priceContainer.classList.add('price--on-sale');
            salePriceContainer.style.display = "flex";
            if (saleEl && originalEl) {
              if( this.mainComparePrice != "0" ) {
                originalEl.innerText = formattedDiscounted;
              } else {
                originalEl.innerText = formattedActual;
              }
              saleEl.innerText = formattedDiscountedBasePrice;
              if ( unitPriceContainer) {
                unitEl.innerText = formattedUnitPrice;
              }
            }
          }
        }

        if(sellingPlanGroupDefaultPricePerValue) {
          sellingPlanGroupDefaultPricePerValue.innerText = formattedDiscounted;
        }

        if(subscriptionPlanPerDeliveryPrice) {
          subscriptionPlanPerDeliveryPrice.innerHTML = formattedSubscription;
        }
      }
    }
  }

  onThumbnailChange(event) {
    const volumeMedia = event.detail.volumeMedia;
    if (!volumeMedia) return;
    const swatch = this.querySelector(`#volume-swatch-${volumeMedia}`);
    if (!swatch) return;
    this.swatches.forEach(el => el.classList.remove('selected'));
    swatch.classList.add('selected');
    const quantity = Number(swatch.dataset.itemQty);
    const basePrice = Number(swatch.dataset.price);
    const discountValue = Number(swatch.dataset.discountValue);
    const comparePrice = Number(swatch.dataset.comparePrice);

    this.updateQuantity(quantity, basePrice, discountValue, comparePrice);
  }

}
if (!window.customElements.get("bso-quantity-variants")) {
  window.customElements.define("bso-quantity-variants", BsoQuantityVariants);
}
class BsoVariantDiscounts extends HTMLElement {
  constructor() {
    super();
    this.productJson = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
    this.translations = JSON.parse(document.querySelector('[data-translation-json]').innerHTML);
    this.enableCustomSubscriptionTemplate = document.querySelector('.buy-buttons-form[enable-custom-appstle]');
    
    const { product: jsonProduct, selected_variant_id: initialVariantId } = this.productJson;
    this.productData = jsonProduct;
    this.bsoSellingPlan = document.querySelector('bso-selling-plan');
    this.planInput = document.querySelector('.selling-plan-container input[name="selling_plan"]');
    this.quantityInputElement = document.querySelector('.product__info-container .quantity__input');
    this.variantPills = this.querySelectorAll('.variant-pills input[type="radio"]');
    this.volumeDiscountGallery = document.querySelector('media-gallery.volume-discount-gallery') ?? null;
    this.volumeDiscountThumbnail = this.volumeDiscountGallery?.querySelector('.thumbnail-slider') ?? null;
    this.volumeDiscountMediaCount = this.volumeDiscountGallery ? this.volumeDiscountGallery.querySelectorAll('.product__media-list .product__media-item').length : 0;
    this.toRenderPriceAdjustment = null;
    this.defaultVariantSelected = null;
    this.defaultRadioSelected = this.querySelector('.variant-pills .default-variant-pill:checked') || null;
    if(this.defaultRadioSelected) {
      this.defaultVariantSelected = this.productData.variants.find(variant => variant.id == Number(this.defaultRadioSelected.dataset.variantId));
    }
    this.eventName = null;
    this.updateQuantity = null;

    document.addEventListener('variant:change', (event) => {
      this.handleSetSellingPlanInput(event);
      this.eventName = 'variantChange';
      this.detachAppstleWidget();
    });

    this._onVariantPillChange = (event) => {
      this.eventName = 'variantPillChange';
      this.detachAppstleWidget();
    };
    
    this._onSellingPlanGroupSelect = (event) => {
      event.detail.variant = this.defaultVariantSelected;
      this.eventName = 'sellingPlanGroupSelect';
      this.handleSetSellingPlanInput(event);
      this.detachAppstleWidget();
    };

    document.addEventListener('volume:thumbnail-change', this.onThumbnailChange.bind(this));

    requestAnimationFrame(() => {
      this.initQuantityInputListener();
    });

    if ( this.enableCustomSubscriptionTemplate ) {
      this.detachAppstleWidget();
    }
  }

  detachAppstleWidget() {
    setTimeout(() => {
      const appstleSubscription = document.querySelector('.appstle_sub_widget');
      if (appstleSubscription) {
        appstleSubscription.remove();
      }
    }, 1500);
  }

  connectedCallback() {
    document.addEventListener('variantPillChange', this._onVariantPillChange);
    document.addEventListener('sellingPlanGroupSelect', this._onSellingPlanGroupSelect);
  }

  disconnectedCallback() {
    document.removeEventListener('variantPillChange', this._onVariantPillChange);
    document.removeEventListener('sellingPlanGroupSelect', this._onSellingPlanGroupSelect);
  }

  handleSetSellingPlanInput(event) {
    let selectedVariant = event.detail && event.detail.variant ? event.detail.variant : null;
    let planGroupId = null;
    if (!selectedVariant) return;
    this.defaultVariantSelected = selectedVariant;
    let sellingPlanAllocation = null;
    if (selectedVariant.selling_plan_allocations && selectedVariant.selling_plan_allocations.length > 0) {
      sellingPlanAllocation = selectedVariant.selling_plan_allocations[0];
      planGroupId = selectedVariant.selling_plan_allocations[0].selling_plan_group_id;
    }

    let currentSelectedSwatch = this.querySelector('.variant-pills input:checked');
    let quantity = Number(this.quantityInputElement.value || this.updateQuantity || currentSelectedSwatch?.dataset.itemQty );

    if( event.type == 'variant:change' && event.type != null ) {
      quantity = currentSelectedSwatch.dataset.itemQty;
    }

    this.updateQuantity = quantity;

    const volume_discount = {
      "variant_swatch": Boolean(currentSelectedSwatch?.dataset.variantSwatch === 'true'),
      "quantity": quantity,
      "discount_value": Number(currentSelectedSwatch?.dataset.discountValue || 0),
      "discount_type": currentSelectedSwatch?.dataset.discountType || null,
      "base_price": Number(currentSelectedSwatch?.dataset.price || selectedVariant.price),
      "compare_price": Number(currentSelectedSwatch?.dataset.comparePrice || 0),
      "total_compare_price": Number(currentSelectedSwatch?.dataset.totalcomparePrice || 0),
      "unit_price": Number(currentSelectedSwatch?.dataset.unitPrice || selectedVariant.unit_price),
      "reference_unit": currentSelectedSwatch?.dataset.unitPriceMeasurement || selectedVariant.unit_price_measurement.reference_unit,
      "quantity_value": Number(currentSelectedSwatch?.dataset.unitQuantityValue || selectedVariant.unit_price_measurement.quantity_value)
    };

    this.updateMediaGallery(currentSelectedSwatch);
    if(this.bsoSellingPlan) {
      this.renderSellingPlanHtml(event);
      if(!sellingPlanAllocation) return;
      this.setSellingPlanInput(selectedVariant, sellingPlanAllocation, volume_discount);
    } else {
      this.renderPdpPrice(selectedVariant, volume_discount);
    }
  }
  
  setSellingPlanInput(variant, sellingPlanAllocation, volume_discount) {
    if ( !variant && !sellingPlanAllocation && !volume_discount && this.planInput && this.productData ) return;
    const selectedSwatch = volume_discount;
    const selectedPlanGroupElement = document.querySelector('.selling-plan-group.active');
    let activePlanGroup = "default";
    
    if (!selectedPlanGroupElement) return;
    if (selectedPlanGroupElement.dataset.planGroupId != 'default') {
      this.planInput.value = sellingPlanAllocation.selling_plan_id || '';
      activePlanGroup = "subscription-plan";
    } else {
      this.planInput.value = '';
    }
    let selectedPlanGroup = null;
    let planGroups = this.productData.selling_plan_groups;
    if( sellingPlanAllocation == null ) return;
    for (const planGroup of planGroups) {
      if (planGroup.id === sellingPlanAllocation.selling_plan_group_id) {
        selectedPlanGroup = planGroup;
        break;
      }
    }

    if (!selectedPlanGroup) return;
    let isVariantSwatch = selectedSwatch.variant_swatch;
    let quantity = selectedSwatch.quantity;
    let discount = selectedSwatch.discount_value;
    let basePrice = selectedSwatch.base_price;
    let comparePrice = selectedSwatch.compare_price;
    let totalComparePrice = selectedSwatch.total_compare_price;
    let unitQuantityValue = selectedSwatch.quantity_value;
    let referenceUnit = selectedSwatch.reference_unit;
    let adjustment;
    let actualPrice = totalComparePrice * quantity;
    let subscriptionDiscount = 1.0;
    let totalWeightKg = quantity * (unitQuantityValue / 1000);

    let defaultPlanGroup = document.querySelector('.selling-plan-group.selling-plan-group--default');
    if (defaultPlanGroup) {
      let defaultPriceEl = defaultPlanGroup.querySelector('.per-delivery-price--value');
      if (isVariantSwatch || quantity == 1) {
        var dpgVariantBasePrice = this.roundPrice(comparePrice) * quantity;
        var basePriceWithDiscount = this.roundPrice(basePrice * discount);
        var dgpTotalComparePrice = this.roundPrice(comparePrice) * quantity;
        var dpgDiscountedPrice = basePriceWithDiscount.toFixed(2) * quantity;
        var dpgSalePrice = dpgDiscountedPrice;
        var dpgRegularPrice = dgpTotalComparePrice;

        var dpgVariantBasePriceFormatted = this.formatMoney(dpgSalePrice);
        var dpgDiscountedUnitPrice = (actualPrice * discount) / totalWeightKg;
        var dpgFormattedUnitPrice = this.formatMoney(dpgDiscountedUnitPrice);
      } else {
        var dpgVariantBasePrice = this.roundPrice(basePrice) * quantity;
        var basePriceWithDiscount = this.roundPrice(basePrice * discount);
        var dpgDiscountedPrice = basePriceWithDiscount.toFixed(2) * quantity;
        var dpgSalePrice = dpgDiscountedPrice;
        var dpgRegularPrice = dpgVariantBasePrice;
        var dpgVariantBasePriceFormatted = this.formatMoney(dpgSalePrice);
        var dpgDiscountedUnitPrice = (sellingPlanAllocation.unit_price * discount) / 100;
        var dpgFormattedUnitPrice = this.formatMoney(dpgDiscountedUnitPrice);
      }

      if ( activePlanGroup === "default" ) {
        this.renderPriceAdjustment(isVariantSwatch, dpgSalePrice, dpgRegularPrice, dpgDiscountedUnitPrice, quantity, activePlanGroup);
      }

      if (defaultPriceEl) {
        var defaultPriceElHtml = '';
        defaultPriceElHtml += dpgVariantBasePriceFormatted;
        defaultPriceElHtml += `<br><span class="unit-price">${dpgFormattedUnitPrice}/${referenceUnit}</span>`;
        defaultPriceEl.innerHTML = defaultPriceElHtml;
      }
    }

    const subscriptionPlanGroup = document.querySelector('.selling-plan-group.subscription-plan');
    if (subscriptionPlanGroup && selectedPlanGroup) {
      subscriptionPlanGroup.setAttribute('data-plan-group-id', selectedPlanGroup.id);
      const subscriptionLabel = subscriptionPlanGroup.querySelector('.selling-plan-group--input-text');
      if (subscriptionLabel) {
        subscriptionLabel.innerHTML = '';
        subscriptionLabel.innerHTML += `<div>${selectedPlanGroup.name}</div>`;
      }

      const firstPlan = selectedPlanGroup.selling_plans[0];
      const discountBadgeElement = subscriptionPlanGroup.querySelector('.appstle-save-badge');
      if( firstPlan.price_adjustments && firstPlan.price_adjustments.length > 0 ) {
        adjustment = firstPlan.price_adjustments[0];
        if( adjustment.value_type === 'percentage' ) {
          if (discountBadgeElement) {
            discountBadgeElement.innerHTML = this.translations.badge_discount_label + ' ' + adjustment.value + '%' + this.translations.savings;
          } else {
            subscriptionLabel.innerHTML += '<div class="appstle-save-badge">'+ this.translations.badge_discount_label + ' ' + adjustment.value + '%' + this.translations.savings + '</div>';
          }
        }
      }

      const selector = subscriptionPlanGroup.querySelector('.selling-plan-group--selling-plan-selector');
      if (selector) {
        selector.innerHTML = '';
        selectedPlanGroup.selling_plans.forEach(plan => {
          const option = document.createElement('option');
          option.value = plan.id;
          option.textContent = plan.name;
          selector.appendChild(option);
        });
      }

      const subscriptionPriceEl = subscriptionPlanGroup.querySelector('.per-delivery-price--value');
      subscriptionDiscount = (100 - adjustment.value) / 100;
      if (isVariantSwatch && quantity == 1) {
        var priceWithSubscriptionDiscount = basePrice * discount;
        priceWithSubscriptionDiscount = priceWithSubscriptionDiscount.toFixed(2) * subscriptionDiscount;
        priceWithSubscriptionDiscount = priceWithSubscriptionDiscount.toFixed(2) * quantity;
        var subSalePrice = priceWithSubscriptionDiscount;
        var priceWithSubscriptionDiscountFormatted = this.formatMoney(subSalePrice);

        var discountedPrice = (comparePrice * quantity) * discount;
        var subRegularPrice = discountedPrice;
        var variantBasePriceFormatted = this.formatMoney(subRegularPrice);

        var unitPrice = sellingPlanAllocation.unit_price / 100;
        var formattedUnitPrice = this.formatMoney(unitPrice);
      } else {
        var priceWithSubscriptionDiscount = this.roundPrice(basePrice * discount);
        priceWithSubscriptionDiscount = this.roundPrice(priceWithSubscriptionDiscount.toFixed(2) * subscriptionDiscount);
        priceWithSubscriptionDiscount = this.roundPrice(priceWithSubscriptionDiscount.toFixed(2) * quantity);
        var subSalePrice = priceWithSubscriptionDiscount;

        var variantBasePrice = comparePrice;
        variantBasePrice = this.roundPrice(variantBasePrice) * quantity;
        var subRegularPrice = variantBasePrice;

        var priceWithSubscriptionDiscountFormatted = this.formatMoney(subSalePrice);
        var variantBasePriceFormatted = this.formatMoney(subRegularPrice);

        var unitPrice = sellingPlanAllocation.unit_price * discount * subscriptionDiscount;
        unitPrice = unitPrice / 100;
        var formattedUnitPrice = this.formatMoney(unitPrice);
      }

      if ( activePlanGroup === "subscription-plan" ) {
        this.renderPriceAdjustment(isVariantSwatch, subSalePrice, subRegularPrice, unitPrice, quantity, activePlanGroup);
      }

      if(subscriptionPriceEl) {
        var subscriptionPriceElHtml = '';
        subscriptionPriceElHtml += priceWithSubscriptionDiscountFormatted;
        subscriptionPriceElHtml += ` <span class="line-through">${variantBasePriceFormatted}</span>`;
        subscriptionPriceElHtml += `<br><span class="unit-price">${formattedUnitPrice}/${referenceUnit}</span>`;
        subscriptionPriceEl.innerHTML = subscriptionPriceElHtml;
      }
    }
  }

  renderPriceAdjustment(isVariantSwatch, salePrice, regularPrice, unitPrice, quantity, activePlanGroup) {
    const regularPriceContainer = document.querySelector(".product__info-container .price__regular");
    const priceContainer = document.querySelector(".product__info-container .pdp-price > .price");
    const salePriceContainer = document.querySelector(".product__info-container .price__sale");
    const unitPriceContainer = document.querySelector(".product__info-container .pdp-price .unit-price");
    const unitEl = unitPriceContainer.querySelector("span[data-unit-price] price-money bdi");
    const regularEl = regularPriceContainer.querySelector(".price-item--regular bdi");

    if (!isVariantSwatch) {
      regularPriceContainer.style.display = "none";
      salePriceContainer.style.display = "flex";
      priceContainer.classList.add('price--on-sale');
      const saleEl = salePriceContainer.querySelector("dd .price-item--sale bdi");
      const originalEl = salePriceContainer.querySelector("dd .price-item--regular bdi");
      if (saleEl && originalEl) {
        originalEl.innerText = this.formatMoney(regularPrice);
        saleEl.innerText = this.formatMoney(salePrice);
        if (unitPriceContainer) {
          unitEl.innerText = this.formatMoney(unitPrice);
        }
      }
    } else {
      const saleEl = salePriceContainer.querySelector("dd .price-item--sale bdi");
      const originalEl = salePriceContainer.querySelector("dd .price-item--regular bdi");
      if (saleEl && originalEl) {
        if (activePlanGroup != "subscription-plan") {
          salePriceContainer.style.display = "flex";
          priceContainer.classList.add('price--on-sale');
          if ( regularPrice != 0 && regularPrice < salePrice ) {
            originalEl.innerText = this.formatMoney(regularPrice);
            saleEl.innerText = this.formatMoney(salePrice);
            if (unitPriceContainer) {
              unitEl.innerText = this.formatMoney(unitPrice);
            }
          } else {
            if ( regularPrice == salePrice ) {
              priceContainer.classList.remove('price--on-sale');
              salePriceContainer.style.display = "none"
              regularPriceContainer.style.display = "block";
              salePriceContainer.style.display = "none";
              regularPriceContainer.style.display = "block";
              priceContainer.classList.remove('price--on-sale');
              regularEl.innerText = this.formatMoney(regularPrice);

            } else {
              priceContainer.classList.add('price--on-sale');
              salePriceContainer.style.display = "flex";
              regularPriceContainer.style.display = "none";
              originalEl.innerText = this.formatMoney(regularPrice);
              saleEl.innerText = this.formatMoney(salePrice);
            }
            if (unitPriceContainer) {
              unitEl.innerText = this.formatMoney(unitPrice);
            }
          }
        } else {
          if ( regularPrice == salePrice ) {
            salePriceContainer.style.display = "none";
            regularPriceContainer.style.display = "block";
            priceContainer.classList.remove('price--on-sale');
            regularEl.innerText = this.formatMoney(regularPrice);
          } else {
            salePriceContainer.style.display = "flex";
            regularPriceContainer.style.display = "none";
            priceContainer.classList.add('price--on-sale');
            originalEl.innerText = this.formatMoney(regularPrice);
            saleEl.innerText = this.formatMoney(salePrice);
          }
          if (unitPriceContainer) {
            unitEl.innerText = this.formatMoney(unitPrice);
          }
        }
      }
    }
  }

  renderPdpPrice(variant, volume_discount) {
    if ( !variant && !volume_discount && this.productData ) return;
    const selectedSwatch = volume_discount;

    let isVariantSwatch = selectedSwatch.variant_swatch;
    let quantity = selectedSwatch.quantity;
    let discount = selectedSwatch.discount_value;
    let basePrice = selectedSwatch.base_price;
    let comparePrice = selectedSwatch.compare_price;
    let unitQuantityValue = selectedSwatch.quantity_value;
    let totalWeightKg = quantity * (unitQuantityValue / 1000);
    let discountedPrice = (comparePrice * quantity) * discount;
    let priceWithDiscount = basePrice * discount;
    let regularPrice;
    let salePrice;
    let unitPrice;
    
    const regularPriceContainer = document.querySelector(".product__info-container .price__regular");
    const priceContainer = document.querySelector(".product__info-container .pdp-price > .price");
    const salePriceContainer = document.querySelector(".product__info-container .price__sale");
    const unitPriceContainer = document.querySelector(".product__info-container .pdp-price .unit-price");
    const unitEl = unitPriceContainer.querySelector("span[data-unit-price] price-money bdi");
    const regularEl = regularPriceContainer.querySelector(".price-item--regular bdi");

    if (isVariantSwatch && quantity == 1) {
      regularPrice = discountedPrice;
      salePrice = priceWithDiscount.toFixed(2) * quantity;
      unitPrice = salePrice / totalWeightKg;
    } else {
      var variantBasePrice = this.roundPrice(basePrice) * quantity;
      regularPrice = variantBasePrice;
      var roundedItemPrice = this.roundPrice(basePrice * discount);
      salePrice = roundedItemPrice * quantity;
      unitPrice = salePrice / totalWeightKg;
    }

    if (!isVariantSwatch) {
      regularPriceContainer.style.display = "none";
      salePriceContainer.style.display = "flex";
      priceContainer.classList.add('price--on-sale');
      const saleEl = salePriceContainer.querySelector("dd .price-item--sale bdi");
      const originalEl = salePriceContainer.querySelector("dd .price-item--regular bdi");
      if (saleEl && originalEl) {
        originalEl.innerText = this.formatMoney(regularPrice);
        saleEl.innerText = this.formatMoney(salePrice);
        if (unitPriceContainer) {
          unitEl.innerText = this.formatMoney(unitPrice);
        }
      }
    } else {
      const saleEl = salePriceContainer.querySelector("dd .price-item--sale bdi");
      const originalEl = salePriceContainer.querySelector("dd .price-item--regular bdi");
      if (saleEl && originalEl) {
        if ( regularPrice == salePrice ) {
          salePriceContainer.style.display = "none";
          regularPriceContainer.style.display = "block";
          priceContainer.classList.remove('price--on-sale');
          regularEl.innerText = this.formatMoney(regularPrice);
        } else {
          salePriceContainer.style.display = "flex";
          regularPriceContainer.style.display = "none";
          priceContainer.classList.add('price--on-sale');
          originalEl.innerText = this.formatMoney(regularPrice);
          saleEl.innerText = this.formatMoney(salePrice);
        }
        if (unitPriceContainer) {
          unitEl.innerText = this.formatMoney(unitPrice);
        }
      }
    }
  }

  roundPrice(value) {
    return Math.ceil((value + Number.EPSILON) * 100) / 100;
  }

  initQuantityInputListener() {
    if (!this.quantityInputElement) return;
    this.quantityInputElement.addEventListener('change', (event) => {
      const inputQuantity = parseInt(event.target.value, 10) || 1;
      let updatedSwatch = null;
      this.updateQuantity = event.target.value;
      // Find the custom-pill radio matching the current quantity and variant id
      let variantPills = document.querySelectorAll('variant-radios .variant-pills input[type="radio"]');
      let currentSwatch = document.querySelector('variant-radios .variant-pills input[type="radio"]:checked');
      if (this.defaultVariantSelected) {
        const pills = Array.from(variantPills).filter(radio => radio.dataset.variantId == this.defaultVariantSelected.id);
        let targetPill = pills.find(radio => Number(radio.dataset.itemQty) === inputQuantity);
        if (!targetPill) {
          const below = pills.filter(radio => Number(radio.dataset.itemQty) < inputQuantity);
          if (below.length > 0) {
            targetPill = below.reduce((max, curr) => Number(curr.dataset.itemQty) > Number(max.dataset.itemQty) ? curr : max);
            updatedSwatch = targetPill;
          }
        }
        if (targetPill) {
          if (currentSwatch) currentSwatch.checked = false;
          targetPill.checked = true;
          updatedSwatch = targetPill;
        }
      }

      this.handleSetSellingPlanInput({
        detail: {
          variant: this.defaultVariantSelected,
          trigger: 'quantity_input_change',
          quantity: inputQuantity,
          updatedSwatch: updatedSwatch
        }
      });
    });
  }

  formatMoney(value) {
    return "€" + value.toFixed(2).replace('.', ',');
  }

  renderSellingPlanHtml(event) {
    if(event.type != 'variant:change') return;
    if(!this.defaultVariantSelected) return;
    const currentVariant = this.defaultVariantSelected;
    const bsoSellingPlan = document.querySelector('bso-selling-plan');

    if (currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length != 0) {
      bsoSellingPlan.classList.remove('hidden');
    } else {
      bsoSellingPlan.classList.add('hidden');
      this.planInput.value = '';
    }
  }

  updateMediaGallery(selectedSwatch) {
    const swatch = selectedSwatch;
    if (!swatch || !swatch.checked) return;
    const swatchNumber = swatch.dataset.swatchNumber;
    this.dispatchEvent(
      new CustomEvent('volume:swatch-change', {
        bubbles: true,
        detail: {
          swatch,
          swatchNumber
        }
      })
    );
  }

  onThumbnailChange(event) {
    const volumeMedia = event.detail.volumeMedia;
    if (!volumeMedia) return;
    const swatch = this.querySelector(`.variant-pill input[type="radio"][data-swatch-number="${volumeMedia}"]`);
    if (!swatch) return;
    this.variantPills.forEach(el => el.checked = false);
    swatch.click();
  }
}

if (!window.customElements.get("bso-variant-discounts")) {
  window.customElements.define("bso-variant-discounts", BsoVariantDiscounts);
}

class BsoSellingPlan extends HTMLElement {
  constructor() {
    super();
    this.productJson = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
    this.translations = JSON.parse(document.querySelector('[data-translation-json]').innerHTML);

    if (this.productJson.product['selling_plan_groups'].length === 0) return;
    const { product: jsonProduct, selected_variant_id: initialVariantId } = this.productJson;
    this.productData = jsonProduct;
    this.currentVariant = null;
    this.currentPlan = null;
    this.currentAllocation = null;
    this.variantChanged = false;
    this.planInput = document.querySelector('.selling-plan-container input[name="selling_plan"]');
    this.planElements = { default: {} };
    this.volumeSwatch = document.querySelector('.quantity-selector-container');
    // Create object for easy lookup of selling plans
    this.productData['selling_plan_groups'].forEach((group) => {
      this.planElements[group.id] = { options: {} };
      group['selling_plans'].forEach((plan) => {
        this.planElements[group.id][plan.id] = plan;
      });
    });

    // Create object for easy lookup of selling plan selector elements]
    this.querySelectorAll('.selling-plan-group').forEach((groupElement) => {
      if (!groupElement.dataset['planGroupId']) return;
      const groupData = this.planElements[groupElement.dataset['planGroupId']];
      const plans = groupElement.querySelectorAll('input[name^="purchase_option"], select[name^="purchase_option"] option');
      groupData.element = groupElement;
      groupData.displayed = groupElement.hasAttribute('disabled') ? false : true;
      plans.forEach((plan) => {
        const option = plan.closest('[data-option-name]').dataset.optionName;
        groupData.options[option] = groupData.options[option] || {};
        groupData.options[option][plan.value] = {};
        groupData.options[option][plan.value].element = plan;
        groupData.options[option][plan.value].displayed = plan.hasAttribute('disabled') ? false : true;
        groupData.options[option][plan.value].show = false;
      });
    });

    // Bind event listeners
    this.querySelectorAll('[name^="purchase_option"]').forEach(input => {
      input.addEventListener('change', this.onPlanSelect.bind(this));
    });
    this.querySelectorAll('input[name="selling_plan_group"]').forEach(input => {
      input.addEventListener('change', this.onGroupSelect.bind(this));
    });
  }

  onGroupSelect(e) {
    const groupElement = e.target.closest('.selling-plan-group');
    this.onGroupDeselect(this.querySelector('.selling-plan-group.active'));
    groupElement.classList.add('active');
   
    const collapsibleContent = groupElement.querySelector('.selling-plan-group--content.collapsible-inner');
    if (collapsibleContent) {
      collapsibleContent.classList.add('active');
      collapsibleContent.setAttribute('aria-expanded', 'true');
    }

    if (groupElement.dataset.planGroupId !== 'default') {
      const select = groupElement.querySelector('select');
      if (select && select.options.length > 0) {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change'));
      } else {
        const radio = groupElement.querySelector('input[type="radio"][name^="purchase_option"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change'));
        } else {
        }
      }
    } else {
      const checkedRadio = this.querySelector('input[name^="purchase_option"]:checked');
      if (checkedRadio) checkedRadio.checked = false;
      this.selectPlan(null);
    }
    const is_default = e.target.closest('.selling-plan-group').classList.contains('selling-plan-group--default');
    this.dispatchEvent(new CustomEvent('sellingPlanGroupSelect', { bubbles: true, detail: { is_default }}));
  }

  onGroupDeselect(group) {
    group.classList.remove('active');
    const previousPlan = group.querySelector('.selling-plan-group--selling-plan.active');
    if (previousPlan) {
      previousPlan.classList.remove('active');
      const checkedRadio = previousPlan.querySelector('input[name^="purchase_option"]:checked');
      if (checkedRadio) checkedRadio.checked = false;
    }

    const collapsibleContent = group.querySelector('.selling-plan-group--content.collapsible-inner');
    if (collapsibleContent) {
      collapsibleContent.classList.remove('active');
      collapsibleContent.setAttribute('aria-expanded', 'false');
    }
  }

  onPlanSelect(e) {
    const groupElement = e.target.closest('.selling-plan-group');
    const planId = groupElement.querySelector('input[name^="purchase_option"]:checked, select[name^="purchase_option"] option:checked').value;
    if (this.planInput) {
      this.planInput.value = planId || '';
    }
  }

  selectPlan(plan) {
    this.currentPlan = plan;
    this.currentAllocation = null;
    this.planInput.value = plan ? plan.id : '';
  }
}
if (!window.customElements.get("bso-selling-plan")) {
  window.customElements.define("bso-selling-plan", BsoSellingPlan);
}